export const roundUp = (number: number, digits: number) => {
    const factor = Math.pow(10, digits);
    return Math.ceil(number * factor) / factor;
};

export const roundDown = (number: number, digits: number) => {
    const factor = Math.pow(10, digits);
    return Math.floor(number * factor) / factor;
};

export const convertDecimals = (obj: any): any => {
    if (Array.isArray(obj)) {
        return obj.map(element => convertDecimals(element));
    } else if (typeof obj === 'object' && obj !== null) {
        return Object.keys(obj).reduce((acc: any, key) => {
            acc[key] = convertDecimals(obj[key]);
            return acc;
        }, {});
    } else {
        return typeof obj === 'number' ? roundTwoDecimal(obj) : obj;
    }
};

export const roundTwoDecimal = (number: number) => Math.round(number * 100) / 100;

export const roundThreeDecimal = (number: number) => Math.round(number * 1000) / 1000;

export const roundFourDecimal = (number: number) => Math.round(number * 10000) / 10000;

export const roundSixDecimal = (number: number) => Math.round(number * 1000000) / 1000000;

export const roundTwelveDecimal = (number: number) => Math.round(number * 1e12) / 1e12;

export const degreesToRadians = (degrees: number) => degrees * (Math.PI / 180);

export const getYProjection = (value: number, angle: number) => value * Math.sin(degreesToRadians(angle));

export const getXProjection = (value: number, angle: number) => value * Math.cos(degreesToRadians(angle));
